import { Instance, applySnapshot, flow, getParent, getSnapshot, types } from 'mobx-state-tree';

import { deleteMedia } from '@common/api/media';
import { deletePoliciesItem, getPoliciesItem, updatePoliciesItem } from '@common/api/policies';
import Group from '@common/models/Groups/Group';
import Location from '@common/models/Locations/Location';
import Media from '@common/models/Media';
import { IPoliciesModel } from '@common/models/Policies/Policies';

const PoliciesItem = types
	.model('PoliciesItem', {
		id: types.identifierNumber,
		title: types.optional(types.string, ''),
		locations: types.optional(types.array(Location), []),
		groups: types.optional(types.array(Group), []),
		file_url: types.maybeNull(types.string),
		image_url: types.maybeNull(types.string),
		file: types.maybeNull(Media),
		image: types.maybeNull(Media),
	})
	.volatile(() => ({
		loading: false,
	}))
	.views(() => ({}))
	.actions((self) => ({
		fetch: flow(function* () {
			self.loading = true;

			try {
				const result = yield getPoliciesItem(self.id);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
		remove: flow(function* () {
			self.loading = true;

			try {
				yield deletePoliciesItem(self.id);
				const parent = getParent<IPoliciesModel>(self, 2);
				parent.removeItem(self as IPoliciesItemModel);
			} catch (e) {
				self.loading = false;
			}
		}),
		save: flow(function* (data: any, isGetSnapshot: boolean = true) {
			self.loading = true;
			try {
				const result = yield updatePoliciesItem(
					self.id,
					isGetSnapshot
						? {
								...getSnapshot(self),
								...data,
							}
						: data,
				);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
		deleteCover: flow(function* () {
			yield deleteMedia({ id: self.id, entity: 'polices', media_collection: 'image' });
		}),
	}));

export default PoliciesItem;

export interface IPoliciesItemModel extends Instance<typeof PoliciesItem> {}
